/*eslint-disable*/
import { useState, useEffect } from "react";
import { Link, useParams, useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFaceSmile, faFaceMeh, faFaceFrown } from '@fortawesome/free-regular-svg-icons';
import {
    Spinner,
    UncontrolledTooltip,
} from 'reactstrap';

import ChangelogsDetails from "./ChangelogDetails";
import PublicChangelogList from './ChangelogLists';

import client from "../../../common/api";

import './changelog.public.scss';

const PublicChangelogs = ({
    poweredBy,
    companyInfo
}) => {
    const match = { params: useParams() };
    const navigate = useNavigate();
    const hostUrl = window.location.host;
    const companyID = window.location.host.split('.')[0];
    const { search } = useLocation();
    const parameters = new URLSearchParams(search);
    const showDraftLogs = parameters.get('show-draft');
    const isChangeLog = match.params.feature === 'changelog';
    const activeSpace = window.location.host.split('.')[0];

    const [allChangelogList, setAllChangelogList] = useState([]);
    const [changelogList, setChangelogList] = useState([]);
    const [changelogFilterList, setChangelogFilterList] = useState([]);
    const [changelogLoader, setChangelogLoader] = useState(false);
    const [changelogItem, setChangelogItem] = useState({});
    const [changelogSearch, setChangelogSearch] = useState('');
    const [changelogCreated, setChangelogCreated] = useState(false);
    const changelogId = match.params?.slug;

    const openChangelogDetails = (changelog) => {
        navigate(`/changelog/preview/${changelog._id['$oid']}`);
    };

    const getAllChangelogs = () => {
        const _hostUrl = hostUrl.replace("www.", "")
        setChangelogLoader(true);
        client.get(`/changelog/public/${companyID}`, { params: { activeSpaceName: activeSpace, url: _hostUrl } }).then(response => {
            setChangelogLoader(false);
            const changelogResp = response.data.data;
            if (response.data.success) {
                const changelog_list = changelogResp.changelogs;
                setAllChangelogList(changelog_list);
                // loop thr & check if atleat one changelog status is published
                const publishedChangelogs = changelog_list.filter((changelog) => changelog.status === 'published');
                if (publishedChangelogs.length > 0) {
                    setChangelogCreated(true);
                }

                const sorted_changelogs = changelog_list.sort((a, b) => new Date(b.created_at['$date']) - new Date(a.created_at['$date']));
                setChangelogList(sorted_changelogs);
            }
        })
    };

    const getChangelogDetails = (changelogId) => {
        const _hostUrl = hostUrl.replace("www.", "")
        client.get(`/changelog/details/${changelogId}`, { params: { activeSpaceName: activeSpace, url: _hostUrl } }).then(response => {
            if (response.data.success) {
                const changelog_list = response.data.data;
                setChangelogItem(changelog_list);
            }
        })
    };

    const searchChangelogs = (searchText) => {
        setChangelogSearch(searchText);
        if (searchText.length >= 2) {
            const filteredChangelogs = changelogList.filter((changelog) => {
                const title_match = changelog.title.toLowerCase().includes(searchText.toLowerCase());
                const subtitle_match = changelog.subtitle?.toLowerCase().includes(searchText.toLowerCase());
                return title_match || subtitle_match;
            });
            setChangelogList(filteredChangelogs);
        }
        if (searchText.length === 0) {
            setChangelogList(allChangelogList);
        }
    };

    const updateCurrentChangelog = (changelog) => {
        // setChangelogItem(changelog);
        const changelogsCopy = [...allChangelogList];
        changelogsCopy.map((item) => {
            if (item._id['$oid'] === changelog._id['$oid']) {
                item = changelog;
            }
        });
        setAllChangelogList(changelogsCopy);
    };

    const getHtml = (html) => {
        var span = document.createElement('span');
        span.innerHTML = html;
        return span.textContent || span.innerText;
    };

    const reactionsClickHandler = (changelogItem, reaction) => {
        const chId = changelogItem._id['$oid'];
        const {
            reactions
        } = changelogItem;
        if (reactions[reaction]) {
            reactions[reaction] = reactions[reaction] + 1;
        } else {
            reactions[reaction] = 1;
        }
        const _payload = {
            rxn_obj: reactions,
            activeSpaceName: activeSpace
        };

        client.post(`/changelog/reactions/${chId}`, _payload).then(response => {
            if (response.data.success) {
                updateCurrentChangelog(response.data.data);
            } else {

            }
        }).catch(error => {
            console.log('error---', error);
        });
    };

    const SmileyReactions = ({ changelog }) => {
        return (
            <>
                {/* <p className="reactions-header">Reactions</p> */}
                <div className="changelog-reactions-row smiley">
                    <span className="_option" onClick={() => reactionsClickHandler(changelog, 'like')}>
                        <FontAwesomeIcon icon={faFaceSmile} id="smileTooltip" />
                        {
                            changelog.reactions['like'] > 0 && (
                                <span className="_count">{changelog.reactions['like']}</span>
                            )
                        }

                        <UncontrolledTooltip
                            placement="top"
                            target="smileTooltip"
                        >Like</UncontrolledTooltip>
                    </span>
                    <span className="_option" onClick={() => reactionsClickHandler(changelog, 'meh')}>
                        <FontAwesomeIcon icon={faFaceMeh} id="mehTooltip" />
                        {
                            changelog.reactions['meh'] > 0 && (
                                <span className="_count">{changelog.reactions['meh']}</span>
                            )
                        }
                        <UncontrolledTooltip
                            placement="top"
                            target="mehTooltip"
                        >Meh</UncontrolledTooltip>
                    </span>
                    <span className="_option" onClick={() => reactionsClickHandler(changelog, 'sad')}>
                        <FontAwesomeIcon icon={faFaceFrown} id="sadTooltip" />
                        {
                            changelog.reactions['sad'] > 0 && (
                                <span className="_count">{changelog.reactions['sad']}</span>
                            )
                        }
                        <UncontrolledTooltip
                            placement="top"
                            target="sadTooltip"
                        >Sad</UncontrolledTooltip>
                    </span>
                </div>
            </>
        );
    };

    const changeTagFilter = (tag) => {
        setChangelogFilterList([
            ...changelogFilterList,
            tag
        ])
        const filteredChangelogs = allChangelogList.filter((changelog) => changelog.tags?.includes(tag));
        setChangelogList(filteredChangelogs);
    };

    useEffect(() => {
        if (isChangeLog && !match.params?.slug) {
            getAllChangelogs();
        }
    }, [match.params?.slug]);

    useEffect(() => {
        if (isChangeLog && changelogId) {
            getChangelogDetails(changelogId);
        }
    }, [changelogId]);

    return (
        <div className="changelog-section">
            {
                (changelogId && Object.keys(changelogItem).length > 0) ? (
                    <ChangelogsDetails
                        changelogItem={changelogItem}
                        SmileyReactions={SmileyReactions}
                    />
                ) : (
                    <>
                        {
                            changelogLoader ? (
                                <div className="changelog-loader">
                                    <Spinner>Loading...</Spinner>
                                </div>
                            ) : (
                                <PublicChangelogList
                                    changelogList={changelogList}
                                    allChangelogList={allChangelogList}
                                    searchChangelogs={searchChangelogs}
                                    changelogSearch={changelogSearch}
                                    showDraftLogs={showDraftLogs}
                                    openChangelogDetails={openChangelogDetails}
                                    getHtml={getHtml}
                                    changeTagFilter={changeTagFilter}
                                    changelogFilterList={changelogFilterList}
                                    setAllChangelogList={setAllChangelogList}
                                    clearFilters={() => setChangelogFilterList([])}
                                    companyInfo={companyInfo}
                                />
                            )}
                    </>
                )
            }
            <p className="poweredby-link">
                <a href={poweredBy} target="_blank">
                    <svg width="8" height="15" stroke="#000000a2"
                        stroke-width="2" style={{ marginRight: '4px' }}>
                        <path fill="#F9C933" fill-rule="evenodd" stroke="#EE8B00" stroke-width=".8" d="M4.256 5.777h3.65L.716 15.935l2.721-7.927H.14l6.503-10.08-2.387 7.849z"></path>
                    </svg>
                    by ProductLogz
                </a>
            </p>
        </div >
    );
};

export default PublicChangelogs;
